import { faker } from '@faker-js/faker'

import { WordType } from '../../contracts/lucybot'
import { WordItem } from '../../contracts/lucybot/WordItem'
import { asBuilder } from '../asBuilder'

export const getWordItem = asBuilder((): WordItem => {
  return {
    description: faker.lorem.word(),
    boundingPoly: {
      vertices: faker.helpers.multiple(
        () => ({
          x: faker.number.int(),
          y: faker.number.int(),
        }),
        { count: 4 },
      ),
    },
    normalizedVertices: faker.helpers.multiple(
      () => ({
        x: faker.number.int(),
        y: faker.number.int(),
      }),
      { count: 4 },
    ),
    type: faker.helpers.arrayElement(Object.values(WordType)),
    imageIndex: faker.number.int(),
  }
})
